import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";

const state = {

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
